// Minimal stroked SVG icons — matches the design's monochrome line-icon set.
// One component per icon keeps them tree-shakable.
import React from 'react';

const wrap = (paths) => {
  const Icon = ({ size = 16, stroke = 1.6, className = 'ic' }) => (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {paths}
    </svg>
  );
  return Icon;
};

export const IHome = wrap(
  <path d="M3 10l9-7 9 7v10a2 2 0 01-2 2h-4v-7h-6v7H5a2 2 0 01-2-2z" />
);
export const IBook = wrap(
  <path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z" />
);
export const IChart = wrap(
  <>
    <line x1="3" y1="21" x2="21" y2="21" />
    <line x1="7" y1="21" x2="7" y2="11" />
    <line x1="12" y1="21" x2="12" y2="5" />
    <line x1="17" y1="21" x2="17" y2="14" />
  </>
);
export const IKey = wrap(
  <>
    <circle cx="8" cy="15" r="4" />
    <path d="M10.8 12L20 3l2 2-3 3 2 2-2 2-2-2-3 3" />
  </>
);
export const IShield = wrap(<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />);
export const ISearch = wrap(
  <>
    <circle cx="11" cy="11" r="8" />
    <line x1="21" y1="21" x2="16.65" y2="16.65" />
  </>
);
export const ICopy = wrap(
  <>
    <rect x="9" y="9" width="13" height="13" rx="2" />
    <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
  </>
);
export const IPlay = wrap(<polygon points="5 3 19 12 5 21 5 3" />);
export const IHash = wrap(
  <>
    <line x1="4" y1="9" x2="20" y2="9" />
    <line x1="4" y1="15" x2="20" y2="15" />
    <line x1="10" y1="3" x2="8" y2="21" />
    <line x1="16" y1="3" x2="14" y2="21" />
  </>,
);
export const ITrash = wrap(
  <>
    <polyline points="3 6 5 6 21 6" />
    <path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6" />
  </>
);
export const ICheck = wrap(<polyline points="20 6 9 17 4 12" />);
export const ISlash = wrap(
  <>
    <circle cx="12" cy="12" r="10" />
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
  </>
);
export const IMenu = wrap(
  <>
    <line x1="3" y1="6" x2="21" y2="6" />
    <line x1="3" y1="12" x2="21" y2="12" />
    <line x1="3" y1="18" x2="21" y2="18" />
  </>
);
export const IX = wrap(
  <>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </>
);
export const ILogout = wrap(
  <>
    <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </>
);
export const IEye = wrap(
  <>
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8S1 12 1 12z" />
    <circle cx="12" cy="12" r="3" />
  </>
);
export const IEyeOff = wrap(
  <>
    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19m-6.72-1.07a3 3 0 11-4.24-4.24" />
    <line x1="1" y1="1" x2="23" y2="23" />
  </>
);
export const IArrowUp = wrap(
  <>
    <line x1="12" y1="19" x2="12" y2="5" />
    <polyline points="5 12 12 5 19 12" />
  </>
);
export const IChevronDown = wrap(<polyline points="6 9 12 15 18 9" />);
export const IChevronUp = wrap(<polyline points="18 15 12 9 6 15" />);
